angular
	.module 'App.Component'
	.component 'treeViewItemComponent',
	{
		templateUrl: '@component/tree-view/item/tree-view.item.view.html'
		controller: 'TreeViewItemComponent'
		controllerAs: 'treeItem'
		bindings:
			nodes: '<'
			selectedNodeId: '@'
			parentDepth: '<depth'
			onSelect: '&'
			onToggle: '&'
	}

class TreeViewItemComponent extends AbstractController
	@register()

	initialize: ->
		@depth = @parentDepth + 1
